import { Progress, type ProgressProps } from '@components/atoms/Progress/Progress';
import type { TvChannelShowtime } from '@src/lib/graphql/generated';
import { useCurrentTime } from '@src/lib/hooks/useCurrentTime';
import { createDate } from '@src/utils/dateHelpers';
import { differenceInMilliseconds, isAfter } from 'date-fns';
import { useEffect, useState } from 'react';

export interface ShowtimeProgressProps {
  showtime: TvChannelShowtime;
  progressClassProps?: ProgressProps['classProps'];
  onShowEnded?: () => void;
}

export const ShowtimeProgress = ({ showtime, onShowEnded, progressClassProps }: ShowtimeProgressProps) => {
  const [showEnded, setShowEnded] = useState(false);
  const { currentTime } = useCurrentTime();

  const startTime = showtime ? createDate(showtime?.start) : null;
  const endTime = showtime ? createDate(showtime?.stop) : null;

  useEffect(() => {
    if (endTime && isAfter(currentTime, endTime)) {
      setShowEnded(true);
      onShowEnded?.();
    }
  }, [currentTime, endTime, onShowEnded]);

  if (!showtime || showEnded) return null;

  let progress = 0;
  if (!isAfter(currentTime, endTime)) {
    progress = (differenceInMilliseconds(startTime, currentTime) / differenceInMilliseconds(startTime, endTime)) * 100;
    progress = progress > 100 ? 100 : progress;
  }

  return <Progress percentage={progress} classProps={progressClassProps} />;
};
